import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const customersModule: ForqModuleManifest = {
  id: 'customers',
  name: 'Kunden',
  description: 'Kunden, Anschriften und Ansprechpartner verwalten',
  version: '0.2.0',
  route: '/kunden',
  category: 'masterdata',
  status: 'development',
  requiredPermissions: ['customers.view'],
  features: [
    'customers.list',
    'customers.details',
    'customers.create',
    'customers.edit',
    'customers.addresses',
    'customers.contacts',
    'customers.duplicates',
  ],
  navigation: [
    { id: 'customers.primary', label: 'Kunden', route: '/kunden', placement: 'primary', order: 20, icon: 'kunden' },
    { id: 'customers.launcher', label: 'Kunden', route: '/kunden', placement: 'launcher', order: 20, icon: 'kunden' },
  ],
};

export const customersFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'customers.list', moduleId: 'customers', name: 'Kundenliste',
    description: 'Mandantenbezogene Kundensuche und Ergebnisliste', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.view'], uiSlots: [], emits: ['customer.opened'], listensTo: ['tenant.changed'],
  },
  {
    id: 'customers.details', moduleId: 'customers', name: 'Kundendetails',
    description: 'Stammdaten, Anschriften und Ansprechpartner', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.view'], uiSlots: [], emits: [], listensTo: ['customer.opened'],
  },
  {
    id: 'customers.create', moduleId: 'customers', name: 'Kunde anlegen',
    description: 'Neue Kunden mit atomarer Kundennummer anlegen', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.create'], uiSlots: [], emits: ['customer.created'], listensTo: [],
  },
  {
    id: 'customers.edit', moduleId: 'customers', name: 'Kunde bearbeiten',
    description: 'Kundenstammdaten und Status bearbeiten', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.edit'], uiSlots: [], emits: ['customer.updated'], listensTo: [],
  },
  {
    id: 'customers.addresses', moduleId: 'customers', name: 'Anschriften',
    description: 'Rechnungs-, Liefer- und Einsatzanschriften verwalten', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.edit'], uiSlots: [], emits: ['customer.address.updated'], listensTo: [],
  },
  {
    id: 'customers.contacts', moduleId: 'customers', name: 'Ansprechpartner',
    description: 'Ansprechpartner eines Kunden verwalten', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.contacts.manage'], uiSlots: [], emits: ['customer.contact.updated'], listensTo: [],
  },
  {
    id: 'customers.duplicates', moduleId: 'customers', name: 'Dublettenprüfung',
    description: 'Mögliche Dubletten vor dem Speichern prüfen', version: '0.2.0', defaultEnabled: true,
    requiredPermissions: ['customers.view'], uiSlots: [], emits: ['customer.duplicate.detected'], listensTo: [],
  },
];
